<template>
  <b-card
    v-if="userData"
    class="profile-card mb-2"
  >
    <div class="d-flex align-items-center">
      <div class="profile-icon mr-3">
        <feather-icon
          icon="UserIcon"
          size="24"
        />
      </div>
      <div>
        <small class="text-muted">Bienvenido</small>
        <h5 class="mb-0 font-weight-bold">
          {{ userData.fullName }}
        </h5>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
    components: { BCard },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
        }
    },
}
</script>

<style scoped>
.profile-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 12px;
}
.profile-card .text-muted {
    color: rgba(255, 255, 255, 0.7) !important;
}
.profile-card h5 {
    color: #fff;
}
.profile-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
</style>
